import { render, staticRenderFns } from "./QRPreRegister.vue?vue&type=template&id=03da124c&scoped=true"
import script from "./QRPreRegister.vue?vue&type=script&lang=js"
export * from "./QRPreRegister.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03da124c",
  null
  
)

export default component.exports